import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table          : 'CI_REFERENCE',
    fieldMap       : {
        id              : 'CIR_ID',
        srcItemId       : 'CIR_CI_ID_SRC',
        destItemId      : 'CIR_CI_ID_DEST',
        referenceSetId  : 'CIR_CIRS_ID',
        statusId        : 'CIR_CIST_ID',
        modifierUserId  : 'CIR_MODIFIER',
        modificationTime: 'CIR_MODIFICATION_TIME',
        validatorUserId : 'CIR_VALIDATOR',
        validationTime  : 'CIR_VALIDATION_TIME'
    },
    historyFieldMap: {
        id            : 'CIR_ID',
        srcItemId     : 'CIR_CI_ID_SRC',
        destItemId    : 'CIR_CI_ID_DEST',
        referenceSetId: 'CIR_CIRS_ID',
        statusId      : 'CIR_CIST_ID',
        modifierUserId: 'CIR_MODIFIER',
        validFromTime : 'CIR_VALID_FROM',
        validToTime   : 'CIR_VALID_TO'
    },
    fieldTypesMap  : {
        id              : 'INTEGER',
        srcItemId       : 'INTEGER',
        destItemId      : 'INTEGER',
        referenceSetId  : 'INTEGER',
        statusId        : 'INTEGER',
        modifierUserId  : 'STRING',
        modificationTime: 'TIMESTAMP',
        validatorUserId : 'STRING',
        validationTime  : 'TIMESTAMP',
        validFromTime   : 'TIMESTAMP',
        validToTime     : 'TIMESTAMP'
    }
};

export default tableDefinition;
